














































































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {LongueursVente} from '@/models';

import CrudLongueursVenteFilter from '@/components/Crud/LongueursVente/Filter.vue';
import CrudLongueursVenteEditDialog from '@/components/Crud/LongueursVente/EditDialog.vue';
import CrudLongueursVenteList from '@/components/Crud/LongueursVente/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeLongueursVente from '@/stores/modules/longueursVente';

@Component({
	components: {
		CrudLongueursVenteFilter,
		CrudLongueursVenteEditDialog,
		CrudLongueursVenteList,
		CrudDeleteDialog,
	}
})
export default class LongueursVenteView extends Vue {
	
	@Stored(() => storeLongueursVente)
	private longueursVentes!: ResultType<LongueursVente>;
	
	private editLongueursVente: LongueursVente = null;
	private deletedLongueursVente: LongueursVente = null;
	private storeLongueursVente = storeLongueursVente;
	
	@Emit()
	private onCreate(): void {
		this.editLongueursVente = new LongueursVente();
	}

	private refresh(): void {
		storeLongueursVente.dispatch('getC', { filters: true });
	}
}
